import { RoutesInterface } from '@g17eco/types/routes';

export const emissionsCalculatorsRoutes: RoutesInterface = {
  EMISSIONS_CALCULATORS: {
    id: 'emissions_calculators',
    label: 'Emissions: Carbon Calculators',
    path: '/emissions-calculator',
    exact: true,
    icon: 'fa-calculator',
    auth: true,
  },
  EMISSIONS_PARTNER: {
    id: 'emissions_calculators_partner',
    label: 'Emissions Calculator Partner',
    path: '/emissions-calculator/:partnerCode',
    exact: false,
    icon: 'fa-calculator',
    auth: true,
  },
  SIMPLE_CARBON_CALCULATOR: {
    id: 'simple_emissions_calculators',
    label: 'Simple Emissions Calculator',
    path: '/emissions-calculator/simple',
    exact: true,
    icon: 'fa-calculator',
    auth: true,
  },
};
